var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import SweetScroll from 'sweet-scroll';
/**
 *  Scroll - Decorates given component with scoll functionality
 */
export var Scroll = function (props) {
    var children = props.children, duration = props.duration, easing = props.easing, positionAfterScroll = props.positionAfterScroll, render = props.render, rest = __rest(props, ["children", "duration", "easing", "positionAfterScroll", "render"]);
    var scroller = new SweetScroll(__assign({ duration: duration, easing: easing }, rest));
    var scrollTo = function () {
        scroller.to(positionAfterScroll);
    };
    return props.render(scrollTo);
};
Scroll.defaultProps = {
    duration: 600,
    easing: 'easeOutQuint',
};
export default Scroll;
//# sourceMappingURL=index.js.map